import PriceRange from './PriceRange';

export * from './types';

export default PriceRange;
